















































































import { Component, Prop, Vue } from "vue-property-decorator";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

import DoKoCardSelectionHtml from "../controls/DoKoCardSelectionHtml.vue";

import { Action, Getter } from "vuex-class";
import { api as deskApi } from "../../store/modules/desk";
import { Decks } from "../../store/modules/desk/types";
import { Dictionary } from "lodash";
import {
  FriendRef,
  PossibleRestriction,
  Restriction,
  CARDS,
} from "@dokogd/shared";

@Component({
  components: {
    DoKoHtmlDialog,
    DoKoBtn,
    DoKoCardSelectionHtml,
  },
})
export default class DoKoDialogPovertyCheck extends Vue {
  handoverCards: CARDS[] = [];

  @Getter(deskApi.getters.getMyCards, { namespace: deskApi.namespace })
  myCards!: CARDS[];

  @Getter(deskApi.getters.getPovertyInfo, { namespace: deskApi.namespace })
  povertyInfo!: {
    playerId: string;
    cards: string[];
    sendCards: boolean;
  };

  @Getter(deskApi.getters.getMappedUsers, { namespace: deskApi.namespace })
  mappedUsers!: Dictionary<FriendRef>;

  @Getter(deskApi.getters.getLoadingState, { namespace: deskApi.namespace })
  loading!: boolean;

  @Action(deskApi.actions.povertyCheckChoice, {
    namespace: deskApi.namespace,
  })
  povertyCheckChoice!: (accept: boolean) => Promise<void>;
  @Action(deskApi.actions.returnPovertyCards, {
    namespace: deskApi.namespace,
  })
  returnPovertyCards!: (cards: CARDS[]) => Promise<void>;

  get acceptance() {
    return !this.povertyInfo.sendCards;
  }
  get player() {
    return this.mappedUsers[this.povertyInfo.playerId];
  }

  get playerName() {
    return this.player.displayName;
  }

  get avatarId() {
    return this.player.avatarId;
  }

  get sendDisabled() {
    return !(this.myCards.length - this.handoverCards.length === 10);
  }

  get handoverCardCount() {
    return this.myCards.length - 10;
  }

  get disabledCards() {
    return this.handoverCards.length < this.handoverCardCount
      ? this.handoverCards
      : this.myCards;
  }

  get selectedCards() {
    const a = [...this.handoverCards, null, null, null, null].slice(
      0,
      this.handoverCardCount
    );
    console.log(a);
    return a.map((v) => {
      if (v) {
        return {
          name: v.substr(0, 2),
          id: v,
        };
      } else {
        return {
          name: "basis",
          id: null,
        };
      }
    });
  }

  unselect(cardId: string | null) {
    if (cardId !== null) {
      this.handoverCards = this.handoverCards.filter((c) => c !== cardId);
    }
  }

  sendReturnPovertyCards() {
    console.log(
      "sendReturnPovertyCards",
      this.povertyInfo,
      this.handoverCards,
      this.myCards
    );
    this.returnPovertyCards(this.handoverCards);
  }
}
